<template>
  <div id="app">
    <sign-in v-if="!isLogin"></sign-in>

    <div class="main" v-else>
      <Header v-if="!isMobile"></Header>
      <div class="content" v-if="!isMobile">
        <side-nav></side-nav>
        <div class="right-content">
          <router-view />
        </div>
      </div>

      <div class="m-content" v-else>
        <m-header></m-header>
        <router-view />
      </div>
    </div>

    <!-- 选择人员 -->
    <contacts v-if="contactShow"></contacts>

    <!-- 审批节点 -->
    <approval v-if="approvalId"></approval>

    <!-- 打印 -->
    <print v-if="printData.isPrint"></print>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Header from './components/Header'
  import MHeader from './components/MHeader'
  import SideNav from './components/SideNav'
  import SignIn from './components/SignIn'

  import Contacts from './components/ContactsPop'
  import Approval from './components/Approval'
  import Print from './page/print/index'
  export default {
    name: 'App',
    computed: {
      ...mapState({
        nowRouterUrl: state => state.main.nowRouterUrl,
        contactShow: state => state.main.contactShow,
        approvalId: state => state.main.approvalId,
        userData: state => state.main.userData,

        isMobile: state => state.main.isMobile,
        printData: state => state.main.printData,
      })
    },
    data() {
      return {
        isLogin: true,
      }
    },
    components: {
      Header,
      MHeader,
      SideNav,
      SignIn,
      Contacts,
      Approval,
      Print,
    },
    mounted() {
      this.setLoginState()
      // 获取组织树
      this.getContactsList()
    },
    methods: {
      // 获取更新组织树
      getContactsList() {
        ajax.get('/dept/list', '', (res) => {
          this.$store.commit('set_organization', res.vo.array)
        })
      },
      // 设置登录状态
      setLoginState() {
        if (this.userData && this.userData.accesstoken) {
          this.isLogin = true
        } else {
          this.isLogin = false
        }
      }
    },
    watch: {
      userData() {
        this.setLoginState()
      }
    }
  }
</script>

<style src="./assets/icon/iconfont.css"></style>
<style lang="scss">
  // 引用全局的scss
  @import "./assets/reset.scss";
  @import "./assets/main.scss";
  @import "./assets/query.scss";
  @import "./assets/m.scss";
</style>


// WEBPACK FOOTER //
// src/App.vue